export function getLang(languageType) {
  if (languageType == 'ZHO') {
    return 'CMN'
  }

  return !['CMN', 'ENG', 'VIE'].includes(languageType) ? 'ENG' : languageType
}